/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyBudgets = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        categories: {
    type: 'array',
    contains: {
        type: 'CategoryBudget',
    },
    isRequired: true,
},
    },
};